export default function holidaySetReducer(holidaySet, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "addHoliday":
      return { ...holidaySet, holidays: [...holidaySet.holidays, action.holiday] };
    case "deleteHoliday":
      return { ...holidaySet, holidays: holidaySet.holidays.filter((_holiday) => _holiday.id !== action.holiday.id) };
    case "updateHoliday": {
      return {
        ...holidaySet,
        holidays: holidaySet.holidays.map((_holiday) => {
          if (_holiday.id === action.holiday.id) {
            return action.holiday;
          }

          return _holiday;
        }),
      };
    }

    default:
      return { ...holidaySet, [action.type]: action.value };
  }
}
